/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

export const INDIVIDUAL = 1;
export const JOINT_TENANT = 2;
export const COLLEGE_SAVINGS = 4;
export const ROTH_ROLLOVER_IRA = 5;
export const TRADITIONAL_IRA = 6;
export const ROTH_IRA = 7;
export const ROLLOVER_IRA = 8;
export const EDUCATION_SAVINGS_ACCOUNTS = 9;
export const UGMA_UTMA = 10;
export const TRUST = 11;
export const CORPORATE = 12;

export const SEP_IRA = 17;
export const SIMPLE_IRA = 18;
export const KEOGH = 19;
export const TRANSFER_ON_DEATH = 26;
export const NON_PROFIT_ORGANIZATION = 27;
export const NON_FIDUCIARY_RETIREMENT_PLAN = 28;
export const SAR_SEP_IRA = 31;
export const TRADITIONAL_IRA_BENE_DEATH = 35;
export const ROTH_IRA_BENE_DEATH = 36;
export const ROTH_IRA_DECEASED = 37;
export const TRADITIONAL_IRA_DECEASED = 38;
export const INDIVIDUAL_401K = 39;
export const POWER_OF_ATTORNEY = 40;
export const ESTATE = 41;
export const RETIREMENT_PLAN_DECEASED = 43;
export const ORGANIZATION = 46;

export const isIRA = (accountTypeId) => {
  return (
    accountTypeId === ROTH_ROLLOVER_IRA ||
    accountTypeId === TRADITIONAL_IRA ||
    accountTypeId === ROLLOVER_IRA ||
    accountTypeId === ROTH_IRA
  );
};

export const isIRADeceased = (accountTypeId) => {
  return (
    accountTypeId === TRADITIONAL_IRA_BENE_DEATH ||
    accountTypeId === ROTH_IRA_BENE_DEATH ||
    accountTypeId === ROTH_IRA_DECEASED ||
    accountTypeId === TRADITIONAL_IRA_DECEASED
  );
};

export const isTracIRA = (accountTypeId) => {
  return (
    accountTypeId === SAR_SEP_IRA ||
    accountTypeId === SEP_IRA ||
    accountTypeId === SIMPLE_IRA
  );
};

export const isEducationSavingsAccount = (accountTypeId) => {
  return accountTypeId === EDUCATION_SAVINGS_ACCOUNTS;
};
export const isIndividualAccount = (accountTypeId) => {
  return accountTypeId === INDIVIDUAL;
};
export const isJointAccount = (accountTypeId) => {
  return accountTypeId === JOINT_TENANT;
};

export const isTransferOnDeath = (accountTypeId) => {
  return accountTypeId === TRANSFER_ON_DEATH;
};

export const isRMDEligibleAccount = (accountTypeId) => {
  if (!accountTypeId) {
    return false;
  }
  return (
    accountTypeId === TRADITIONAL_IRA ||
    accountTypeId === ROLLOVER_IRA ||
    accountTypeId === SEP_IRA
  );
};

export const isTaxableAccount = (accountTypeId) => {
  if (!accountTypeId) {
    return false;
  }
  return (
    accountTypeId === JOINT_TENANT ||
    accountTypeId === INDIVIDUAL ||
    accountTypeId === UGMA_UTMA ||
    accountTypeId === TRUST
  );
};
